<template>
  <div v-if="game.state.screen === 'playing' && game.state.gameplay.currentLevelKey" class="level-display">
    {{ game.state.gameplay.currentLevelKey }}
  </div>
</template>

<script setup>
import { inject } from 'vue';

const game = inject('game');
</script>

<style scoped>
.level-display {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: var(--hw-text);
  font-family: var(--hw-font-display);
  font-size: 20px;
  text-shadow: 1px 1px 2px black;
  z-index: 1000;
  pointer-events: none; /* So it doesn't interfere with game input */
}
</style>
